export default __webpack_public_path__ + "static/media/icon_skill_fist_2.18bf39e6.png";